import { faClose, faEdit, faLink, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ColumnBodyOptions, ColumnProps } from 'primereact/column'
import React, { useContext, useState } from 'react'
import AddAttachmentsRPDropzoneGrid from '../../shared/components/add-attachments-rp-dropzone-grid/AddAttachmentsRPDropzoneGrid'
import RequiredAsterisk from '../../shared/components/required-asterisk/RequiredAsterisk'
import classes from './AddAttachmentsRPTestReport.module.scss'
import AddAttachmentsRPActionRow from '../../shared/components/add-attachments-rp-action-row/AddAttachmentsRPActionRow'
import { DropzoneOptions, useDropzone } from 'react-dropzone'
import { IAddAttachmentsRPTabDefaultProps } from '../../shared/interfaces/IAddAttachmentsRPTabDefaultProps'
import { IAddAttachmentsRPTestReportModel } from '../../shared/interfaces/IAddAttachmentsRPTestReportModel'
import { Dropdown } from 'primereact/dropdown'
import {
  contentGroupKeyName,
  displayUnlinkEcmModalHeader,
  LinkToWbBtnText,
  MAXIMUM_ALLOWED_UPLOAD_RP_FILE_SIZE,
  reportTypeKeyName,
  RPAttachmentLinkButtonEnum,
  RPFileValidatorSuccessMessage,
  UnlinkEcmBtnText,
} from '../../shared/constants/AddAttachmentsRPConstants'
import { AddAttachmentsRPContext } from '../../shared/contexts/AddAttachmentsRPContext'
import { v4 as uuid } from 'uuid'
import { DataTableProps, DataTableRowExpansionTemplate } from 'primereact/datatable'
import { formatRPDate } from '../../shared/helpers/AddAttachmentsRPHelpers'
import AddAttachmentsRPBulkEditDialog from '../../shared/components/add-attachments-rp-bulk-edit-dialog/AddAttachmentsRPBulkEditDialog'
import clsx from 'clsx'
import { AddAttachmentsRPFileValidatorHelper } from '../../shared/helpers/AddAttachmentsRPFileValidatorHelper'
import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'
import AddAttachmentRPTestReportSupportingDocument from './add-attachments-rp-tr-support-doc/AddAttachmentsRPTRSupportDoc'
import { AddAttachmentsRPUtils } from '../../shared/utils/AddAttachmentsRPUtils'
import { IAddAttachmentsRPTRBulkEditDialogProps } from '../../shared/interfaces/non-model/IAddAttachmentsRPTestReportBulkEditDialogProps'
import { Checkbox } from 'primereact/checkbox'
import CertificateDetailsRPStatusIcon from '../../../../certificate-details/certificate-details-rp-attachments/certificate-details-rp-status-icon/CertificateDetailsRPStatusIcon'
import { IAddAttachmentsRPTestSupportingDocumentModel } from '../../shared/interfaces/IAddAttachmentsRPTestSupportingDocumentModel'
import { IConfirmationModalProps } from '../../shared/interfaces/non-model/IConfirmationModalProps'
import CertificateListService from '../../../../../../../services/CertificateListService'
import useToastr from '../../../../../../../hooks/useToastr'
import { CertificateDocumentStatus } from '../../../../../../../enums/CertificateDocumentStatus'
import { Badge } from 'primereact/badge'
import { Calendar } from 'primereact/calendar'
import {
  updateCertDetailsFormValues,
  selectToggleServiceRequest,
  selectCertificateAction,
} from '../../../../../../../features/createCertificate/createCertificateSlice'
import {
  CertificateGroupEnum,
  getAttributeUniqueName,
} from '../../../../../../../utils/constants/certificate.constants'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import AddAttachmentRPLinkTestReportDialog from '../../shared/components/add-attachment-rp-link-test-report-dialog/AddAttachmentRPLinkTestReportDialog'
import CertificateDetailsRPLinkButton from '../../../../certificate-details/certificate-details-rp-attachments/certificate-details-rp-link-button/CertificateDetailsRPLinkButton'
import ConfirmationModal from '../../../../../../../shared/confirmation-modal/ConfirmationModal'
import {
  ecmUnavailableHeader,
  ecmUnavailableMessage,
} from '../../../../../../../utils/constants/ecm.constants'
import { IEcmCertificateDocumentActionRequest } from '../../shared/interfaces/IEcmCertificateDocument'
import useCertificateDocument from '../../../../../../../hooks/useCertificateDocument'
import { SchemeEcmType } from '../../../../../../../enums/SchemeEcmType'

interface AddAttachmentsRPTestReportProps extends IAddAttachmentsRPTabDefaultProps {
  projectNumber: string
  serviceRequestNumber?: string
  issueDate: Date | null
  fileNumber: string
  referenceNumber: string
  standardNumber: string
  certificateNumber: string
  certificateScheme: string
  revisionNumber: string
  rpAttachments: IAddAttachmentsRPTestReportModel[]
  setRPAttachments: React.Dispatch<React.SetStateAction<IAddAttachmentsRPTestReportModel[]>>
  downloadFile: (
    file: IAddAttachmentsRPTestReportModel | IAddAttachmentsRPTestSupportingDocumentModel
  ) => Promise<void>
  setConfirmationModalProps: React.Dispatch<React.SetStateAction<IConfirmationModalProps>>
  shouldUpdateRPAttachments?: () => void
  updateRPAttachmentOnParent?: (updatedRPAttachment: IAddAttachmentsRPTestReportModel[]) => void
  certificateId?: string | undefined
  formValues?: any
  uniqueCertificateId?: string | undefined
  currentStep?: number
}

type BaseDocument = {
  id: string
  ecmFileNodeId?: string | null
  status?: CertificateDocumentStatus | null
}

enum BulkActionType {
  Link = 'link',
  Unlink = 'unlink',
}

const AddAttachmentsRPTestReport = (props: AddAttachmentsRPTestReportProps) => {
  const { referenceNumber, standardNumber } = props
  const addAttachmentsRPContext = useContext(AddAttachmentsRPContext)
  const testReportAllowedFileTypes: string[] = ['PDF']

  const { showError, showSuccess, showWarning, showInfo } = useToastr()
  const dispatch = useDispatch()
  const isServiceRequest = useSelector(selectToggleServiceRequest)
  const certificateAction = useSelector(selectCertificateAction)

  const certificateDocumentHook = useCertificateDocument()
  const [selectedRows, setSelectedRows] = useState<IAddAttachmentsRPTestReportModel[]>([])
  const [childSelectedRows, setChildSelectedRows] = useState<
    IAddAttachmentsRPTestSupportingDocumentModel[]
  >([])
  const [isSelectAll, setIsSelectAll] = useState<boolean>(false)
  const [isShowLinkTestReport, setIsShowLinkTestReport] = useState<boolean>(false)
  const [isSyncAttachmentLoading, setIsSyncAttachmentLoading] = useState(false)
  const [disableBulkButtons, setDisableBulkButtons] = useState(false)
  const [bulkEditDialog, setBulkEditDialog] = useState<IAddAttachmentsRPTRBulkEditDialogProps>({
    dropdownOptions: [],
    title: '',
    visible: false,
    isContentGroup: false,
  })

  const initialConfirmationModalValues: IConfirmationModalProps = {
    onConfirm: () => {},
    onCancel: () => {},
    visible: false,
    headerDisplay: '',
    buttonNoDisplay: 'No',
    buttonYesDisplay: 'Yes',
    confirmationMessageHTML: '',
    style: undefined,
    isSaving: undefined,
  }

  const [confirmationModalProps, setConfirmationModalProps] = useState<IConfirmationModalProps>(
    initialConfirmationModalValues
  )

  const filteredCgDropdownFirstLevelOptions = AddAttachmentsRPUtils.filterCgFirstLevelOptions(
    AddAttachmentsRPUtils.transformDropdownOptions(
      addAttachmentsRPContext.ecmCategoryModel,
      contentGroupKeyName
    )
  )

  const rtDropdownOptions = AddAttachmentsRPUtils.transformDropdownOptions(
    addAttachmentsRPContext.ecmCategoryModel,
    reportTypeKeyName
  )

  const actionHeaderTemplate = () => {
    const mapPayload = (files: BaseDocument[]) => ({
      certificateNumber: props.certificateNumber,
      documents: files.map(file => ({
        certificateDocumentId: file.id,
        ecmFileNodeId: file.ecmFileNodeId ?? '',
        workbenchCertificateId: props.certificateId ?? '',
      })),
    })

    const updateStatusOptimistic = (
      allowedStatus: CertificateDocumentStatus,
      inProgressStatus: CertificateDocumentStatus
    ) => {
      const selectedIds = [
        ...selectedRows.map(f => f.id),
        ...childSelectedRows
          .filter(row =>
            AddAttachmentsRPUtils.isDocumentAllowedToLink(
              props.certificateScheme,
              row.contentGroup,
              row.attachmentType
            )
          )
          .map(f => f.id),
      ]

      props.setRPAttachments(prev =>
        prev.map(item => {
          const updatedParent =
            selectedIds.includes(item.id) && item.status === allowedStatus
              ? { ...item, status: inProgressStatus }
              : item

          const updatedChildren = item.supportingDocuments?.map(child => {
            if (
              selectedIds.includes(child.id) &&
              AddAttachmentsRPUtils.isDocumentAllowedToLink(
                props.certificateScheme,
                child.contentGroup,
                child.attachmentType
              ) &&
              child.status === allowedStatus
            ) {
              return { ...child, status: inProgressStatus }
            }
            return child
          })

          return {
            ...updatedParent,
            supportingDocuments: updatedChildren,
          }
        })
      )
    }

    const applyResultUpdate = (updatedAttachments: any[]) => {
      const updatedMap = new Map(updatedAttachments.map(f => [f.id, f]))

      props.setRPAttachments(prev =>
        prev.map(item => {
          const parentDoc = updatedMap.get(item.id)

          const updatedParent = parentDoc
            ? { ...item, status: parentDoc.status ?? item.status }
            : item

          const updatedChildren = item.supportingDocuments?.map(child => {
            const childDoc = updatedMap.get(child.id)

            if (
              childDoc &&
              AddAttachmentsRPUtils.isDocumentAllowedToLink(
                props.certificateScheme,
                child.contentGroup,
                child.attachmentType
              )
            ) {
              return {
                ...child,
                status: childDoc.status ?? child.status,
              }
            }

            return child
          })

          return {
            ...updatedParent,
            supportingDocuments: updatedChildren,
          }
        })
      )

      setSelectedRows(prev =>
        prev.map(item => {
          const doc = updatedMap.get(item.id)
          return doc ? { ...item, status: doc.status ?? item.status } : item
        })
      )

      setChildSelectedRows(prev =>
        prev.map(item => {
          const doc = updatedMap.get(item.id)

          if (
            doc &&
            AddAttachmentsRPUtils.isDocumentAllowedToLink(
              props.certificateScheme,
              item.contentGroup,
              item.attachmentType
            )
          ) {
            return {
              ...item,
              status: doc.status ?? item.status,
            }
          }

          return item
        })
      )
    }

    const revertStatus = (files: BaseDocument[]) => {
      const originalStatusMap = files.reduce<Record<string, CertificateDocumentStatus | null>>(
        (acc, file) => {
          acc[file.id] = file.status ?? null
          return acc
        },
        {}
      )

      props.setRPAttachments(prev =>
        prev.map(item => {
          const revertedParent =
            originalStatusMap[item.id] !== undefined
              ? { ...item, status: originalStatusMap[item.id] }
              : item

          const revertedChildren = item.supportingDocuments?.map(child => {
            if (
              originalStatusMap[child.id] !== undefined &&
              AddAttachmentsRPUtils.isDocumentAllowedToLink(
                props.certificateScheme,
                child.contentGroup,
                child.attachmentType
              )
            ) {
              return {
                ...child,
                status: originalStatusMap[child.id],
              }
            }
            return child
          })

          return {
            ...revertedParent,
            supportingDocuments: revertedChildren,
          }
        })
      )
    }

    const executeBulkAction = async (type: BulkActionType) => {
      setDisableBulkButtons(true)

      const isUnlink = type === BulkActionType.Unlink

      const filteredParent = selectedRows.filter(file =>
        isUnlink
          ? file.status === CertificateDocumentStatus.LinkedToWbAndEcmTic
          : file.status === CertificateDocumentStatus.SavedInEcmTic
      )

      const filteredChild = childSelectedRows.filter(
        file =>
          AddAttachmentsRPUtils.isDocumentAllowedToLink(
            props.certificateScheme,
            file.contentGroup,
            file.attachmentType
          ) &&
          (isUnlink
            ? file.status === CertificateDocumentStatus.LinkedToWbAndEcmTic
            : file.status === CertificateDocumentStatus.SavedInEcmTic)
      )

      const filtered = [...filteredParent, ...filteredChild]

      if (filtered.length === 0) {
        setDisableBulkButtons(false)
        return
      }

      const payload = mapPayload(filtered)

      showInfo(
        'Document Linking/Unlinking in Progress',
        'Documents are being linked to/unlinked from Workbench. You will receive a notification once completed.'
      )

      updateStatusOptimistic(
        isUnlink
          ? CertificateDocumentStatus.LinkedToWbAndEcmTic
          : CertificateDocumentStatus.SavedInEcmTic,
        isUnlink
          ? CertificateDocumentStatus.UnlinkingInProgress
          : CertificateDocumentStatus.UploadToEcmInProgress
      )

      try {
        setConfirmationModalProps(initialConfirmationModalValues)
        const result = isUnlink
          ? await CertificateListService.bulkUnlinkEcmDocument(payload)
          : await CertificateListService.bulkLinkEcmDocument(payload)

        if (!result?.isSuccess) {
          showError(
            'Unable to Process Linking/Unlinking to Workbench',
            'Linking/Unlinking of documents could not be completed because Workbench is currently unavailable. Please Try again once Workbench is back online (see status bar).'
          )
        }

        applyResultUpdate(result?.data ?? [])
      } catch (err) {
        showError(
          'Network Error',
          'Failed to process request. Please check your connection and try again.'
        )
        revertStatus(filtered)
      } finally {
        setDisableBulkButtons(false)
        setSelectedRows([])
        setChildSelectedRows([])
        setIsSelectAll(false)
      }
    }

    const openUnlinkDialog = () => {
      setDisableBulkButtons(true)
      setConfirmationModalProps(current => ({
        ...current,
        visible: true,
        headerDisplay: displayUnlinkEcmModalHeader,
        confirmationMessageHTML: displayUnlinkEcmModalText(),
        onCancel: () => {
          setConfirmationModalProps(initialConfirmationModalValues)
          setDisableBulkButtons(false)
        },
        onConfirm: () => {
          executeBulkAction(BulkActionType.Unlink)
        },
      }))
    }

    const parentUnlinkCount = selectedRows.filter(
      row => row.status === CertificateDocumentStatus.LinkedToWbAndEcmTic
    ).length
    const childUnlinkCount = childSelectedRows.filter(
      row =>
        AddAttachmentsRPUtils.isDocumentAllowedToLink(
          props.certificateScheme,
          row.contentGroup,
          row.attachmentType
        ) && row.status === CertificateDocumentStatus.LinkedToWbAndEcmTic
    ).length

    const unlinkCount = parentUnlinkCount + childUnlinkCount

    const parentLinkCount = selectedRows.filter(
      row => row.status === CertificateDocumentStatus.SavedInEcmTic
    ).length
    const childLinkCount = childSelectedRows.filter(
      row =>
        AddAttachmentsRPUtils.isDocumentAllowedToLink(
          props.certificateScheme,
          row.contentGroup,
          row.attachmentType
        ) && row.status === CertificateDocumentStatus.SavedInEcmTic
    ).length

    const linkCount = parentLinkCount + childLinkCount

    return (
      <>
        <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
          <span
            onClick={unlinkCount > 0 && !disableBulkButtons ? openUnlinkDialog : undefined}
            style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}
          >
            <span
              style={{
                opacity: unlinkCount > 0 && !disableBulkButtons ? 1 : 0.5,
                pointerEvents: unlinkCount > 0 && !disableBulkButtons ? 'auto' : 'none',
              }}
            >
              ({unlinkCount})
            </span>
            <span
              className={`${classes['text-btn']} ${classes['unlinkEcm']}`}
              style={{
                opacity: unlinkCount > 0 && !disableBulkButtons ? 1 : 0.5,
                pointerEvents: unlinkCount > 0 && !disableBulkButtons ? 'auto' : 'none',
              }}
            >
              <FontAwesomeIcon className={classes['icons']} icon={faLink} />
              {UnlinkEcmBtnText}
            </span>
          </span>

          <span
            onClick={() => {
              if (linkCount > 0 && !disableBulkButtons) {
                executeBulkAction(BulkActionType.Link)
              }
            }}
            style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}
          >
            <span
              style={{
                opacity: linkCount > 0 && !disableBulkButtons ? 1 : 0.5,
                pointerEvents: linkCount > 0 && !disableBulkButtons ? 'auto' : 'none',
              }}
            >
              ({linkCount})
            </span>
            <span
              className={`${classes['text-btn']} ${classes['linkToWb']}`}
              style={{
                opacity: linkCount > 0 && !disableBulkButtons ? 1 : 0.5,
                pointerEvents: linkCount > 0 && !disableBulkButtons ? 'auto' : 'none',
              }}
            >
              <FontAwesomeIcon className={classes['icons']} icon={faLink} />
              {LinkToWbBtnText}
            </span>
          </span>
        </div>
      </>
    )
  }

  const handleChangeIssueDate = (
    value: Date | Date[] | string | undefined | null,
    data: IAddAttachmentsRPTestReportModel
  ) => {
    if (Array.isArray(value)) value = value[0]

    data.issueDate = value ? moment(value).format('YYYY-MM-DD') : null
    data.supportingDocuments = data.supportingDocuments.map(supportingDoc => {
      supportingDoc.issueDate =
        supportingDoc.contentGroup === 'TRCertificate' ? data.issueDate : null
      return supportingDoc
    })

    const dateValue = moment(value).format('YYYY-MM-DD')
    if (props?.formValues) {
      const localCertDetails = JSON.parse(JSON.stringify(props?.formValues))
      const fileNameIndex = data.documentFileName.lastIndexOf('.')
      const fileName = data.documentFileName.slice(0, fileNameIndex)
      const testReportNumbers =
        props?.formValues[
          getAttributeUniqueName(CertificateGroupEnum.Certificate, 'testReportNumber')
        ]

      if (testReportNumbers?.length > 1) {
        const reportNoIndex = testReportNumbers.findIndex(
          (report: any) => report.toLocaleLowerCase() === fileName.toLocaleLowerCase()
        )

        if (reportNoIndex >= 0) {
          localCertDetails[
            getAttributeUniqueName(CertificateGroupEnum.Certificate, 'testReportIssueDate')
          ][reportNoIndex] = dateValue

          dispatch(updateCertDetailsFormValues(localCertDetails))
        }
      } else {
        localCertDetails[
          getAttributeUniqueName(CertificateGroupEnum.Certificate, 'testReportIssueDate')
        ][0] = dateValue

        dispatch(updateCertDetailsFormValues(localCertDetails))
      }
    }

    props.setRPAttachments(structuredClone(props.rpAttachments))
  }

  const getDefaultIssueDate = (documentFileName: string) => {
    let defaultIssueDate
    if (props?.formValues) {
      const fileNameIndex = documentFileName.lastIndexOf('.')
      const fileName = documentFileName.slice(0, fileNameIndex)
      const testReportNumbers =
        props?.formValues[
          getAttributeUniqueName(CertificateGroupEnum.Certificate, 'testReportNumber')
        ]

      const testReportIssueDates =
        props?.formValues[
          getAttributeUniqueName(CertificateGroupEnum.Certificate, 'testReportIssueDate')
        ]

      if (testReportNumbers?.length === 1) defaultIssueDate = testReportIssueDates[0]
      else if (testReportNumbers?.length > 1) {
        const reportNoIndex = testReportNumbers.findIndex(
          (report: any) => report.toLocaleLowerCase() === fileName.toLocaleLowerCase()
        )

        if (reportNoIndex >= 0) {
          defaultIssueDate =
            props?.formValues[
              getAttributeUniqueName(CertificateGroupEnum.Certificate, 'testReportIssueDate')
            ][reportNoIndex]
        } else defaultIssueDate = null
      }
    } else defaultIssueDate = formatRPDate(props?.issueDate)
    return defaultIssueDate
  }

  const isSelectableRow = (row: IAddAttachmentsRPTestReportModel) => row.isValid

  const handleCheckboxSelection = (
    isHeaderCheckbox: boolean,
    isChecked: boolean,
    data?: IAddAttachmentsRPTestReportModel
  ) => {
    const cloneCurrentSelection = structuredClone(selectedRows)

    const selectableRows = props.rpAttachments.filter(isSelectableRow)

    if (isHeaderCheckbox) {
      if (isChecked) {
        setSelectedRows(selectableRows)
        setIsSelectAll(true)
      } else {
        setSelectedRows([])
        setIsSelectAll(false)
      }
      return
    }

    if (data && isSelectableRow(data)) {
      const isAlreadySelected = cloneCurrentSelection.some(selected => selected.id === data.id)

      if (!isAlreadySelected) {
        cloneCurrentSelection.push(data)
      } else {
        const index = cloneCurrentSelection.findIndex(selected => selected.id === data.id)
        cloneCurrentSelection.splice(index, 1)
      }

      setSelectedRows(cloneCurrentSelection)

      const isAllSelected = cloneCurrentSelection.length === selectableRows.length

      setIsSelectAll(isAllSelected)
    }
  }

  const testReportColumns: ColumnProps[] = [
    {
      field: 'indicator',
      header: '',
      style: {
        width: '2rem',
        maxWidth: '2rem',
        padding: '0 !important',
        flex: 'none',
      },
      headerStyle: { width: '2rem' },
      body: (data: IAddAttachmentsRPTestReportModel) => {
        const supportingDocumentsLength = data.supportingDocuments.filter(
          suppDocs => suppDocs.status === CertificateDocumentStatus.ReadyToLinkToWbAndEcmTic
        ).length

        return (
          <>
            {supportingDocumentsLength > 0 && (
              <i
                className="pi pi-paperclip p-mr-4 p-text-primary p-overlay-badge"
                style={{
                  fontSize: '1rem',
                  color: '#003357',
                  fontWeight: '500',
                }}
              >
                <Badge
                  className={`${classes['supporting-documents-badge']} `}
                  value={supportingDocumentsLength}
                  size="normal"
                ></Badge>
              </i>
            )}
          </>
        )
      },
    },
    {
      header: options => {
        return (
          <Checkbox
            key={'rp-test-report-checkbox-header'}
            checked={isSelectAll}
            onChange={e => handleCheckboxSelection(true, e.checked)}
          />
        )
      },
      style: { width: '2.75rem', maxWidth: '3.25rem', flex: 'none' },
      headerStyle: { width: '3.25rem' },
      body: (data: IAddAttachmentsRPTestReportModel, options) => {
        return (
          <Checkbox
            key={`checkbox-${data.id} `}
            checked={selectedRows.some(selectedRow => selectedRow.id === data.id)}
            onChange={e => handleCheckboxSelection(false, e.checked, data)}
          />
        )
      },
    },
    {
      header: 'Document File Name',
      field: 'documentFileName',
      style: { width: '15rem', minWidth: '15rem' },
      className: classes['column-flex-style'],
      body: (data: IAddAttachmentsRPTestReportModel) => {
        const fileName = data.ecmFileNodeId
          ? (data.ecmFileName ?? '')
          : (data.documentFileName ?? data.ecmFileName)

        return (
          <span
            className={clsx({
              [classes['add-attachments-rp-cell-link']]: data.ecmFileNodeId,
            })}
            title={fileName}
            onClick={() => (data.ecmFileNodeId ? props.downloadFile(data) : undefined)}
          >
            {fileName}
          </span>
        )
      },
      bodyClassName: `text-container-ellipsis ${classes['add-attachments-rp-cell']} `,
    },
    {
      header: <span style={{ visibility: 'hidden' }}>status</span>,
      field: 'status',
      headerStyle: { width: '36px', maxWidth: '36px', flex: 'none' },
      style: {
        width: '2.5rem',
        maxWidth: '2.5rem',
        textAlign: 'center',
        paddingBottom: '0.25rem',
        paddingLeft: '0.6rem',
        verticalAlign: 'center',
      },
      className: classes['column-flex-style'],
      body: (data: IAddAttachmentsRPTestReportModel, options) => {
        if (data.status === null) return <></>
        const isLinkUnlink =
          data.status === CertificateDocumentStatus.UnlinkingInProgress ||
          data.status === CertificateDocumentStatus.UploadToEcmInProgress

        return (
          <CertificateDetailsRPStatusIcon
            size="1x"
            rpAttachmentFile={data}
            isLinkInProcess={isLinkUnlink}
          />
        )
      },
      bodyClassName: `${classes['add-attachments-rp-cell']} `,
    },
    {
      header: () => {
        return (
          <span>
            File Number
            <RequiredAsterisk style={{ paddingLeft: '0.3rem' }} />
          </span>
        )
      },
      field: 'fileNumber',
      style: { width: '12rem', minWidth: '12rem' },
      className: classes['column-flex-style'],
      body: (data: IAddAttachmentsRPTestReportModel) => {
        const isFieldReadonly = AddAttachmentsRPUtils.isFieldReadonly(
          data.ecmFileNodeId,
          props.isCertificateFromRevision
        )

        return (
          <>
            {isFieldReadonly ? (
              <span title={data.fileNumber}>{data.fileNumber}</span>
            ) : (
              <InputText
                type="text"
                className={clsx(classes['add-attachments-rp-row-input-text'], {
                  'add-attachments-rp-cell-error ': data.isValid && !data.fileNumber,
                })}
                value={data.fileNumber ?? ''}
                onChange={e => handleFileNumberInput(data.id, e.target.value)}
                tooltip={data?.fileNumber ? data.fileNumber : 'File number is required'}
                tooltipOptions={{
                  position: 'bottom',
                }}
                disabled={!data.isValid}
                maxLength={15}
              />
            )}
          </>
        )
      },
      bodyClassName: `text-container-ellipsis ${classes['add-attachments-rp-cell']} `,
    },
    {
      header: 'Project / SR Number',
      field: 'projectNumber',
      style: { width: '12rem', minWidth: '12rem' },
      className: classes['column-flex-style'],
      body: (data: IAddAttachmentsRPTestReportModel) => {
        const serviceNumber = data?.serviceRequestNumber ?? data?.projectNumber
        return <span title={serviceNumber}>{serviceNumber}</span>
      },
      bodyClassName: `text-container-ellipsis ${classes['add-attachments-rp-cell']} `,
    },
    {
      headerClassName: classes['add-attachments-column-with-bulk-edit'],
      className: classes['column-flex-style'],
      header: () => {
        const hasValidSelection =
          selectedRows.length > 0 &&
          selectedRows.some(
            row => row.isValid && !AddAttachmentsRPUtils.isFieldReadonly(row.ecmFileNodeId)
          )

        return (
          <div className={classes['add-attachments-column-with-bulk-edit-row']}>
            <span>
              Content Group
              <RequiredAsterisk style={{ paddingLeft: '0.3rem' }} />
            </span>
            <FontAwesomeIcon
              className={clsx(classes['add-attachments-column-with-bulk-edit-row-icon'], {
                [classes['add-attachments-column-with-bulk-edit-row-icon-disabled']]:
                  !hasValidSelection,
              })}
              icon={faEdit}
              onClick={hasValidSelection ? () => handleBulkEdit(true) : undefined}
            />
          </div>
        )
      },
      body: (data: IAddAttachmentsRPTestReportModel, options: ColumnBodyOptions) => {
        if (
          AddAttachmentsRPUtils.isFieldReadonly(data.ecmFileNodeId, props.isCertificateFromRevision)
        ) {
          return <span>{data.contentGroup}</span>
        }

        return (
          <Dropdown
            className={clsx(classes['add-attachments-rp-dropdown'], {
              'add-attachments-rp-cell-error ': data.isValid && !data.contentGroup,
            })}
            value={data.contentGroup}
            disabled={addAttachmentsRPContext.ecmCategoryDropdownLoading || !data.isValid}
            placeholder={
              addAttachmentsRPContext.ecmCategoryDropdownLoading ? 'Loading...' : 'Select'
            }
            options={filteredCgDropdownFirstLevelOptions}
            dropdownIcon={
              addAttachmentsRPContext.ecmCategoryDropdownLoading
                ? 'pi pi-spin pi-spinner'
                : undefined
            }
            onChange={e => handleDropdownChange(true, data, options.rowIndex, e.value)}
            style={{ width: '100%' }}
            tooltip={data.contentGroup}
            tooltipOptions={{
              position: 'bottom',
              className: classes['add-attachments-rp-dropdown-tooltip'],
            }}
          />
        )
      },
      style: { width: '15rem', minWidth: '15rem' },
    },
    {
      header: 'Issue Date',
      field: 'issueDate',
      className: classes['column-flex-style'],
      body: (data: IAddAttachmentsRPTestReportModel) => {
        const formattedDate = formatRPDate(data?.issueDate?.toString())

        if (data?.ecmFileNodeId) {
          return <span title={formattedDate?.toString()}>{formattedDate}</span>
        } else {
          const issueDate = new Date(formattedDate)
          return (
            <span style={{ height: '2rem', display: 'inline-flex' }}>
              <Calendar
                value={issueDate}
                onChange={e => handleChangeIssueDate(e?.value, data)}
              ></Calendar>
            </span>
          )
        }
      },
      style: { width: '15rem', minWidth: '15rem' },
      bodyClassName: `text-container-ellipsis ${classes['add-attachments-rp-cell']} `,
    },
    {
      headerClassName: classes['add-attachments-column-with-bulk-edit'],
      className: classes['column-flex-style'],
      header: () => {
        const hasValidSelection =
          selectedRows.length > 0 &&
          selectedRows.some(
            row => row.isValid && !AddAttachmentsRPUtils.isFieldReadonly(row.ecmFileNodeId)
          )
        return (
          <div className={classes['add-attachments-column-with-bulk-edit-row']}>
            <span>
              Type
              <RequiredAsterisk style={{ paddingLeft: '0.3rem' }} />
            </span>
            <FontAwesomeIcon
              className={clsx(classes['add-attachments-column-with-bulk-edit-row-icon'], {
                [classes['add-attachments-column-with-bulk-edit-row-icon-disabled']]:
                  !hasValidSelection,
              })}
              icon={faEdit}
              onClick={e => (hasValidSelection ? handleBulkEdit(false) : undefined)}
            />
          </div>
        )
      },
      body: (data: IAddAttachmentsRPTestReportModel, options: ColumnBodyOptions) => {
        if (
          AddAttachmentsRPUtils.isFieldReadonly(data.ecmFileNodeId, props.isCertificateFromRevision)
        ) {
          return <span>{data.type}</span>
        }

        return (
          <Dropdown
            className={clsx(classes['add-attachments-rp-dropdown'], {
              'add-attachments-rp-cell-error ': data.isValid && !data.type,
            })}
            value={data.type}
            disabled={addAttachmentsRPContext.ecmCategoryDropdownLoading || !data.isValid}
            placeholder={
              addAttachmentsRPContext.ecmCategoryDropdownLoading ? 'Loading...' : 'Select'
            }
            options={rtDropdownOptions}
            dropdownIcon={
              addAttachmentsRPContext.ecmCategoryDropdownLoading
                ? 'pi pi-spin pi-spinner'
                : undefined
            }
            onChange={e => handleDropdownChange(false, data, options.rowIndex, e.value)}
            style={{ width: '100%' }}
            tooltip={data.type}
            tooltipOptions={{
              position: 'bottom',
              className: classes['add-attachments-rp-dropdown-tooltip'],
            }}
          />
        )
      },
      style: { width: '14rem', minWidth: '14rem' },
    },
    {
      header: 'Report Number',
      field: 'reportNumber',
      style: { width: '10rem', minWidth: '10rem' },
      className: classes['column-flex-style'],
      body: (data: IAddAttachmentsRPTestReportModel) => {
        if (
          AddAttachmentsRPUtils.isFieldReadonly(data.ecmFileNodeId, props.isCertificateFromRevision)
        ) {
          return <span>{data.reportNumber}</span>
        }

        const isContentGroupOriginal = AddAttachmentsRPUtils.isContentGroupOriginal(
          data.contentGroup
        )
        const isReportNumberRequired = AddAttachmentsRPUtils.isReportNumberRequired(
          data.contentGroup
        )

        return (
          <InputText
            type="text"
            className={clsx(classes['add-attachments-rp-row-input-text'], {
              'add-attachments-rp-cell-error ':
                isReportNumberRequired && data.isValid && !data.reportNumber,
            })}
            disabled={isContentGroupOriginal}
            value={data.reportNumber}
            onChange={e => handleReportNumberInput(data.id, e.target.value)}
            tooltip={
              isReportNumberRequired
                ? 'Enter the original Report Number (e.g., D1) from which this Amendment, Correction, or Reissue derives.'
                : ''
            }
            tooltipOptions={{
              position: 'bottom',
              className: classes['add-attachments-rp-dropdown-tooltip'],
            }}
            maxLength={5}
          />
        )
      },
      bodyClassName: `text-container-ellipsis ${classes['add-attachments-rp-cell']} `,
    },
    {
      header: 'Reference Number',
      field: 'referenceNumber',
      style: { width: '12rem', minWidth: '12rem' },
      body: () => {
        return <span title={referenceNumber}>{referenceNumber}</span>
      },
      className: classes['column-flex-style'],
      bodyClassName: `text-container-ellipsis ${classes['add-attachments-rp-cell']} `,
    },
    {
      header: 'Standard Number',
      field: 'standardNumber',
      style: { width: '12rem', minWidth: '12rem' },
      body: () => {
        return <span title={standardNumber}>{standardNumber}</span>
      },
      className: classes['column-flex-style'],
      bodyClassName: `text-container-ellipsis ${classes['add-attachments-rp-cell']} `,
    },
    {
      header: 'ECM Node ID',
      field: 'ecmFileNodeId',
      style: { width: '10rem', minWidth: '10rem' },
      body: (data: IAddAttachmentsRPTestReportModel) => {
        return <span title={data.ecmFileNodeId}>{data.ecmFileNodeId}</span>
      },
      className: classes['column-flex-style'],
      bodyClassName: `text-container-ellipsis ${classes['add-attachments-rp-cell']} `,
    },
    {
      header: '',
      field: 'fileResult',
      bodyClassName: `${classes['add-attachments-rp-cell']} `,
      body: (data: IAddAttachmentsRPTestReportModel, options: ColumnBodyOptions) => {
        const statusClassName = clsx(
          { [classes['error']]: !data.isValid },
          { [classes['success']]: data.isValid },
          { [classes['warning']]: data.ecmFileNodeId }
        )

        return (
          <>
            <div
              className={clsx(
                classes['add-attachments-rp-file-status-container'],
                'text-overflow-ellipsis'
              )}
              title={data.fileResult}
            >
              <span title={data.fileResult} className={statusClassName}>
                {data.fileResult}
              </span>
            </div>
          </>
        )
      },
      style: {
        flexGrow: 1,
        flexBasis: '20rem',
        width: '20rem',
      },
      align: 'right',
    },
    {
      header: props.isEditOrModify || certificateAction.isWithdraw ? actionHeaderTemplate : '',
      style: {
        minWidth: '2.5rem',
        maxWidth: '',
        flex: '0 0 auto',
        padding: '0',
        paddingRight: '1rem',
        fontWeight: 'normal',
      },
      body: (data: IAddAttachmentsRPTestReportModel, options) => {
        const icon = faLink
        const { label, buttonType, documentAction } =
          data.status === CertificateDocumentStatus.SavedInEcmTic
            ? {
                label: LinkToWbBtnText,
                buttonType: RPAttachmentLinkButtonEnum.linkToWb,
                documentAction: handleLinkToWb,
              }
            : {
                label: UnlinkEcmBtnText,
                buttonType: RPAttachmentLinkButtonEnum.unlinkEcm,
                documentAction: handleUnlinkConfirmationModalProps,
              }

        const isValidToDelete = !data.ecmFileNodeId || data.isToLinkTestReport
        const isValidToLinkUnlink =
          data.status !== null &&
          [
            CertificateDocumentStatus.LinkedToWbAndEcmTic,
            CertificateDocumentStatus.SavedInEcmTic,
          ].includes(data.status as CertificateDocumentStatus) &&
          props.isCertificateFromRevision &&
          !data.isToLinkTestReport

        const isStatusBlue =
          (data.status === CertificateDocumentStatus.ReadyToLinkToWbAndEcmTic ||
            data.status === CertificateDocumentStatus.UploadToEcmFailed) &&
          !data.ecmFileNodeId

        return (
          <>
            {isValidToLinkUnlink && (
              <CertificateDetailsRPLinkButton
                label={label}
                icon={icon}
                linkButtonType={buttonType}
                onClick={() => documentAction(data)}
              />
            )}

            {isValidToDelete && (
              <Button
                className={`p-button-rounded p-button-secondary p-button-text p-button-sm ${classes['add-attachments-rp-file-delete-attachment']}`}
                title="Delete Attachment"
                onClick={() => {
                  if (isStatusBlue) {
                    showDeleteFileBlobPrompt(data, options.rowIndex)
                  } else {
                    handleDeleteFileAttachment(options.rowIndex, data)
                  }
                }}
              >
                <FontAwesomeIcon
                  style={{ color: 'black' }}
                  icon={isStatusBlue ? faTrash : faClose}
                />
              </Button>
            )}
          </>
        )
      },
    },
  ]
  const displayUnlinkEcmModalText = () => {
    return (
      <span>
        This change will not affect the document in ECM TIC.
        <br />
        <br />
        Are you sure you want to unlink the selected Document(s)?
      </span>
    )
  }

  const handleUpdateDocumentsStatus = (status: CertificateDocumentStatus, documentId: string) => {
    props.setRPAttachments((prevState: IAddAttachmentsRPTestReportModel[]) => {
      const newState = prevState.map((document: IAddAttachmentsRPTestReportModel) => {
        if (document.id === documentId) document.status = status

        return document
      })

      if (props.updateRPAttachmentOnParent) props.updateRPAttachmentOnParent(newState)

      return newState
    })
  }

  const handleLinkToWb = async (toLinkDocuments: IAddAttachmentsRPTestReportModel) => {
    if (!toLinkDocuments) return

    const linkRequestProps: IEcmCertificateDocumentActionRequest = {
      certificateDocumentId: toLinkDocuments?.id,
      ecmFileNodeId: toLinkDocuments?.ecmFileNodeId ?? '',
      certificateId: props.certificateId ?? '',
      handleUpdateDocumentsStatus: handleUpdateDocumentsStatus,
    }

    await certificateDocumentHook.handleLinkToWb(linkRequestProps)
  }

  const handleUnlinkFileFromWB = async (toUnlinkDocuments: IAddAttachmentsRPTestReportModel) => {
    if (!toUnlinkDocuments) return
    setConfirmationModalProps(initialConfirmationModalValues)

    const unlinkRequestProps: IEcmCertificateDocumentActionRequest = {
      certificateDocumentId: toUnlinkDocuments?.id,
      ecmFileNodeId: toUnlinkDocuments?.ecmFileNodeId ?? '',
      certificateId: props.certificateId ?? '',
      handleUpdateDocumentsStatus: handleUpdateDocumentsStatus,
    }

    await certificateDocumentHook.handleUnlinkToWb(unlinkRequestProps)
  }

  const handleUnlinkConfirmationModalProps = (
    toUnlinkDocuments: IAddAttachmentsRPTestReportModel
  ) => {
    setConfirmationModalProps(current => {
      return {
        ...current,
        headerDisplay: displayUnlinkEcmModalHeader,
        confirmationMessageHTML: displayUnlinkEcmModalText(),
        visible: true,
        onCancel: () => {
          setConfirmationModalProps(initialConfirmationModalValues)
        },
        onConfirm: () => {
          handleUnlinkFileFromWB(toUnlinkDocuments)
        },
      }
    })
  }

  const handleReportNumberInput = (id: string, value: string) => {
    const cloneCurrent = structuredClone(props.rpAttachments).map(cur => {
      if (cur.id === id) {
        cur.reportNumber = value
      }
      return cur
    })

    props.setRPAttachments(cloneCurrent)
  }

  const handleFileNumberInput = (id: string, value: string) => {
    const cloneCurrent = structuredClone(props.rpAttachments).map(cur => {
      if (cur.id === id) {
        cur.fileNumber = value

        if (cur.supportingDocuments?.length > 0) {
          cur.supportingDocuments.map(supportingDoc => {
            supportingDoc.fileNumber = value
            return supportingDoc
          })
        }
      }
      return cur
    })

    props.setRPAttachments(cloneCurrent)
  }

  const handleDeleteFileAttachment = (index: number, data: IAddAttachmentsRPTestReportModel) => {
    const cloneCurrent = structuredClone(props.rpAttachments)
    let cloneCurrentSelection = structuredClone(selectedRows)

    const getItemIndex = cloneCurrentSelection.findIndex(selected => selected.id === data.id)

    if (getItemIndex >= 0) cloneCurrentSelection.splice(getItemIndex, 1)

    cloneCurrent.splice(index, 1)

    const remainingIds = new Set(cloneCurrent.map(c => c.id))
    cloneCurrentSelection = cloneCurrentSelection.filter(s => remainingIds.has(s.id))
    const selectableCount = cloneCurrent.filter(rpAttachment => rpAttachment.isValid).length

    const isAllChecked = selectableCount > 0 && selectableCount === cloneCurrentSelection.length

    props.setRPAttachments(cloneCurrent)

    if (props.updateRPAttachmentOnParent) props.updateRPAttachmentOnParent(cloneCurrent)

    setSelectedRows(cloneCurrentSelection)
    setIsSelectAll(isAllChecked)
  }

  const handleOnDropFiles = async (incomingFiles: File[]) => {
    const processedFiles = incomingFiles.map(file => {
      const hasExistingFileName = props.rpAttachments.some(
        ({ ecmFileNodeId, ecmFileName, documentFileName }) =>
          (ecmFileNodeId ? ecmFileName : documentFileName) === file.name
      )

      const fileResult = AddAttachmentsRPFileValidatorHelper.Common(
        {
          fileName: file.name,
          fileSize: file.size,
          hasDuplicate: hasExistingFileName,
        },
        {
          maximumFileSizeAllowed: MAXIMUM_ALLOWED_UPLOAD_RP_FILE_SIZE,
          allowedFileTypes: testReportAllowedFileTypes,
        }
      )

      const processedFile: IAddAttachmentsRPTestReportModel = {
        id: uuid(),
        documentFileName: file.name,
        // rpFileNamePreview: "",
        fileNumber: props.fileNumber,
        projectNumber: props.projectNumber,
        serviceRequestNumber: props.serviceRequestNumber,
        contentGroup: '',
        type: '',
        reportNumber: '',
        referenceNumber: props.referenceNumber,
        standardNumber: props.standardNumber,
        revisionNumber: props.revisionNumber,
        issueDate: getDefaultIssueDate(file.name),
        isValid:
          fileResult === RPFileValidatorSuccessMessage.FileUploadedReadyToLink ||
          fileResult === RPFileValidatorSuccessMessage.FileUploadedSuccessful,
        fileResult: fileResult,
        file: file,
        status: null,
        supportingDocuments: [],
        ecmFileName: null,
        isToLinkTestReport: false,
      }

      return processedFile
    })

    props.setRPAttachments(current => [...current, ...processedFiles])

    setIsSelectAll(false)
  }

  const handleDropdownChange = (
    isContentGroup: boolean,
    rowData: IAddAttachmentsRPTestReportModel,
    index: number,
    value: string
  ) => {
    const contentGroup = isContentGroup ? value : rowData.contentGroup
    const type = isContentGroup ? rowData.type : value

    if (!contentGroup || !type) {
      const cloneCurrent = structuredClone(props.rpAttachments).map(current => {
        if (current.id === rowData.id) {
          current.contentGroup = contentGroup
          current.type = type
          current.reportNumber = current.reportNumber

          // update supporting document type column if 1st level type is updated.
          if (!isContentGroup) {
            current.supportingDocuments.map(supportingDocs => {
              supportingDocs.type = type
              return supportingDocs
            })
          }
        }
        return current
      })
      props.setRPAttachments(cloneCurrent)
      return
    }

    const cloneCurrent = structuredClone(props.rpAttachments).map(current => {
      if (current.id === rowData.id) {
        current.contentGroup = contentGroup
        current.type = type

        current.reportNumber = AddAttachmentsRPUtils.isContentGroupOriginal(contentGroup)
          ? ''
          : current.reportNumber

        // update supporting document type column if 1st level type is updated.
        if (!isContentGroup) {
          current.supportingDocuments.map(supportingDocs => {
            supportingDocs.type = type
            return supportingDocs
          })
        }
      }

      return current
    })
    props.setRPAttachments(cloneCurrent)
  }

  const handleBulkEdit = (isContentGroup: boolean) => {
    setBulkEditDialog(current => ({
      ...current,
      dropdownOptions: isContentGroup ? filteredCgDropdownFirstLevelOptions : rtDropdownOptions,
      title: isContentGroup ? 'Content Group' : 'Type',
      visible: true,
      isContentGroup: isContentGroup,
    }))
  }

  const handleBulkEditConfirm = (updatedValue: string) => {
    const updatedGridItems = structuredClone(props.rpAttachments).map((currentValue, index) => {
      if (
        AddAttachmentsRPUtils.isFieldReadonly(
          currentValue.ecmFileNodeId,
          props.isCertificateFromRevision
        )
      ) {
        return currentValue
      }
      if (!selectedRows.some(selected => selected.id === currentValue.id)) return currentValue
      if (bulkEditDialog.isContentGroup) currentValue.contentGroup = updatedValue
      else currentValue.type = updatedValue

      return currentValue
    })
    props.setRPAttachments(updatedGridItems)
    resetBulkEditState()
  }

  const resetBulkEditState = () => {
    setBulkEditDialog(current => ({
      ...current,
      visible: false,
      dropdownOptions: [],
      title: '',
      isContentGroup: false,
    }))
  }

  const dropzoneOptions: DropzoneOptions = {
    onDrop: handleOnDropFiles,
  }

  const dropzone = useDropzone({
    noClick: true,
    noKeyboard: true,
    ...dropzoneOptions,
  })

  const deleteConfirmationMessage = () => {
    return (
      <span>
        The document(s) will be deleted from GMAWB File Storage.
        <br />
        <br />
        Would you like to continue?
      </span>
    )
  }
  const showDeleteFileBlobPrompt = (
    rpAttachment: IAddAttachmentsRPTestReportModel,
    index: number
  ) => {
    props.setConfirmationModalProps(current => ({
      ...current,
      visible: true,
      headerDisplay: 'Delete File Confirmation',
      confirmationMessageHTML: deleteConfirmationMessage(),
      onCancel: () => resetModal(),
      onConfirm: () => handleDeleteFileBlobStorage(rpAttachment, index),
    }))
  }

  const resetModal = () => {
    props.setConfirmationModalProps(AddAttachmentsRPUtils.initialConfirmationModalValues)
  }

  const handleDeleteFileBlobStorage = async (
    rpAttachment: IAddAttachmentsRPTestReportModel,
    index: number
  ) => {
    props.setConfirmationModalProps(current => ({
      ...current,
      isSaving: true,
    }))

    const response = await CertificateListService.deleteFileFromBlob(rpAttachment.id)
    if (response.isSuccess === false) {
      resetModal()
      showError('Error!', 'Attachment(s) has not been deleted.')
      props.setConfirmationModalProps(current => ({
        ...current,
        isSaving: false,
      }))
      return
    } else {
      handleDeleteFileAttachment(index, rpAttachment)

      if (props.shouldUpdateRPAttachments) props.shouldUpdateRPAttachments()

      showSuccess(
        'Success!',
        'Attachment(s) has been deleted successfully from GMAWB File Storage.'
      )
      resetModal()
    }
  }

  const searchAndLinkClick = () => {
    window.open(
      `${AddAttachmentsRPUtils.getWorkbenchDocumentLinkUrl()}${props.certificateId} `,
      '_blank'
    )
  }

  const gridProps: DataTableProps = {
    value: props.rpAttachments,
    size: 'small',
    rowExpansionTemplate: (
      data: IAddAttachmentsRPTestReportModel,
      options: DataTableRowExpansionTemplate
    ) => {
      return (
        <>
          <AddAttachmentRPTestReportSupportingDocument
            rpAttachments={props.rpAttachments}
            setRPAttachments={props.setRPAttachments}
            key={`supporting-document-${data.id}`}
            wrapperClassName={classes['add-attachments-rp-row-expansion-wrapper']}
            actionRowClassName={classes['add-attachments-rp-row-expansion-action-row']}
            gridContainerClassName={classes['add-attachments-rp-grid-wrapper']}
            projectNumber={props.projectNumber}
            serviceRequestNumber={props.serviceRequestNumber}
            issueDate={props?.issueDate}
            fileNumber={data.fileNumber ?? props.fileNumber}
            referenceNumber={props.referenceNumber}
            standardNumber={props.standardNumber}
            certificateNumber={props.certificateNumber}
            revisionNumber={props.revisionNumber}
            parentId={data.id}
            type={data.type}
            value={data.supportingDocuments}
            isCertificateFromRevision={props.isCertificateFromRevision}
            downloadFile={props.downloadFile}
            setConfirmationModalProps={props.setConfirmationModalProps}
            shouldUpdateRPAttachments={props.shouldUpdateRPAttachments}
            isEditOrModify={props.isEditOrModify}
            updateRPAttachmentOnParent={props.updateRPAttachmentOnParent}
            certificateId={props.certificateId}
            currentStep={props.currentStep}
            selectedRows={childSelectedRows}
            setSelectedRows={setChildSelectedRows}
            certificateScheme={props.certificateScheme}
          />
        </>
      )
    },
  }
  const syncProcess = async () => {
    setIsSyncAttachmentLoading(true)
    await CertificateListService.syncDocument(props.uniqueCertificateId)
    const rpAttachments =
      await CertificateListService.getCertificateRPDocumentsByUniqueCertificateId(
        props.uniqueCertificateId
      )

    const transformData = AddAttachmentsRPUtils.mapCertificateAttachmentsToRPModel(
      rpAttachments?.data
    )

    let newlyAddedData = props.rpAttachments.filter(x => x.file != null)
    const modifyTransformData = transformData.map(rpAttachment => {
      //check also supp docs if has newly added
      let checkData = props.rpAttachments.find(x => x.id === rpAttachment.id)
      if (checkData) {
        let hasNewlyAdded = checkData.supportingDocuments.filter(x => x.file != null)
        if (hasNewlyAdded && hasNewlyAdded.length > 0) {
          rpAttachment.supportingDocuments = [...rpAttachment.supportingDocuments, ...hasNewlyAdded]
        }
      }
      return rpAttachment
    })

    const updateAttachmentsData = modifyTransformData.concat(newlyAddedData)

    props.setRPAttachments(updateAttachmentsData)

    setIsSyncAttachmentLoading(false)

    if (props.shouldUpdateRPAttachments) {
      props.shouldUpdateRPAttachments()
    }

    if (props.updateRPAttachmentOnParent) {
      props.updateRPAttachmentOnParent(updateAttachmentsData)
    }
  }

  const handleLinkTestReport = () => {
    setIsShowLinkTestReport(true)
  }

  const onHideLinkTestReport = () => {
    setIsShowLinkTestReport(false)
  }

  return (
    <>
      <div
        {...dropzone.getRootProps({
          className: props.dropzoneUploadClassName,
        })}
        className={classes['add-attachments-rp-grid-main']}
      >
        <input {...dropzone.getInputProps()} />
        {dropzone.isDragActive && props.dropzoneUploadDragElement}
        <AddAttachmentsRPActionRow
          openFileDialog={dropzone.open}
          openSearchAndLink={searchAndLinkClick}
          isEditOrModify={props.isEditOrModify}
          isSyncAttachmentLoading={isSyncAttachmentLoading}
          syncProcess={syncProcess}
          openLinkTestReport={handleLinkTestReport}
        />
        <AddAttachmentsRPDropzoneGrid
          columns={
            props.isCertificateFromRevision || props.isEditOrModify
              ? testReportColumns
              : testReportColumns?.filter(
                  col => col.field !== 'status' && col.field !== 'indicator'
                )
          }
          dropzoneState={dropzone}
          dtProps={gridProps}
          gridContainerClassName={classes['add-attachments-rp-grid-wrapper']}
        />

        <AddAttachmentsRPBulkEditDialog
          title={bulkEditDialog.title}
          dropdownOption={bulkEditDialog.dropdownOptions}
          visible={bulkEditDialog.visible}
          onCancel={resetBulkEditState}
          onConfirm={handleBulkEditConfirm}
        />

        <AddAttachmentRPLinkTestReportDialog
          visible={isShowLinkTestReport}
          onHide={onHideLinkTestReport}
          setRPAttachments={props.setRPAttachments}
          rpAttachments={props.rpAttachments}
        />
        <ConfirmationModal {...confirmationModalProps} />
      </div>
    </>
  )
}

export default AddAttachmentsRPTestReport
